import { IdentityKind } from '@inditex/coanalytjs';
import { COOKIES, getIdentityProvider } from './identity-provider';
import type { IIdentityProvider } from './identity-provider';
import { retrieveCookie } from 'src/utils/browser/cookies';

const mapIdentityKind = (kind?: string): IdentityKind => {
	if (kind === 'registered') return IdentityKind.REGISTERED;
	if (kind === 'persistent') return IdentityKind.PERSISTENT;
	return IdentityKind.GUEST;
};

export const createTrackConfig = (identity?: IIdentityProvider) => {
	const identityProvider = identity ?? getIdentityProvider();
	const userData = identityProvider.getUserData();
	const referrer = document.referrer || '';
	const isInternal = referrer.includes(window.location.hostname);

	return {
		payload: {
			sessionId: identityProvider.getSessionId() ?? '',
			anonymousId: retrieveCookie(COOKIES.UAITXID) ?? '',
			userId: userData.userId ?? '',
			identity: { kind: mapIdentityKind(userData.kind) },
		},
		referrer: { url: isInternal ? '' : referrer },
		utm: {
			source: '',
			medium: '',
			campaign:  '',
			term:  '',
			content: '',
			gclid: '',
			landingUrl: window.location.href,
		},
	};
};
